// extracted by mini-css-extract-plugin
export default {"Main":"LayoutWrapper_Main__JXEsl"};